import React from 'react';
import { GIButton, Modal } from 'app-components';
import { FormattedMessage } from 'react-intl/dist';
import styled from 'styled-components';
import { ModalContextType } from '../../../../contexts/modalContext';
import { IEligibilityDateDetails } from '../../utils';

const StyledModalBoday = styled.div`
    @media (max-width: 768px) {
        .gi-modal__body {
            max-height: 0%;
            padding-bottom: 0px;
        }
    }
`;

const StyledField = styled.div`
    padding: 10px 0px;
`;

const StyledControls = styled.div`
    align-items: right;
`;

interface IModalProps extends ModalContextType {
    overrideEligibilityStartDateData: IEligibilityDateDetails;
}

const OverrideAptcEligibilityStartDateModal = ({ closeModal, overrideEligibilityStartDateData }: IModalProps) => {
    function onClose() {
        closeModal('overrideAptcEligibilityStartDateModal');
    }

    return (
        <Modal id="override_sep_qep_denial_modal">
            <Modal.Header
                id="override_sep_qep_denial_modal_title"
                titleId={'cap.applications.csroption.overrideAPTCEligibilityStartDate'}
                onHide={onClose}
            />
            <StyledModalBoday>
                <Modal.Body>
                    <StyledField>
                        <p>
                            <FormattedMessage id={'cap.applications.column.aptcInfo'} />
                        </p>
                        <p>
                            <FormattedMessage id={'cap.applications.column.enrollmentBeginDate'} />
                            <span>: {overrideEligibilityStartDateData.enrollmentStartDate}</span>
                        </p>
                        <p>
                            <FormattedMessage id={'cap.application.modal.overrideStartDateModal.enrollenddate'} />
                            <span>: {overrideEligibilityStartDateData.enrollmentEndDate}</span>
                        </p>
                        <p>
                            <FormattedMessage id={'cap.applications.column.eligibilityStartDate'} />
                            <span>: {overrideEligibilityStartDateData.financialEffectiveDate}</span>
                        </p>
                    </StyledField>
                </Modal.Body>
            </StyledModalBoday>
            <Modal.Controls>
                <StyledControls>
                    <GIButton id="button" onClickHandler={onClose} variant="primary" labelId={'button.cancel'} />
                </StyledControls>
            </Modal.Controls>
        </Modal>
    );
};

export default OverrideAptcEligibilityStartDateModal;
